module.exports = __webpack_public_path__ + "static/media/chatDislike.38b555c4.svg";